/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `accepted` - Accepted
 * * `pending_send` - Pending Send
 * * `pending_response` - Pending Response
 * * `rejected` - Rejected
 * * `canceled` - Canceled
 */
export enum ConnectionRequestStatus {
    ACCEPTED = 'accepted',
    PENDING_SEND = 'pending_send',
    PENDING_RESPONSE = 'pending_response',
    REJECTED = 'rejected',
    CANCELED = 'canceled',
}
